// extracted by mini-css-extract-plugin
export var active = "_f3-2";
export var recordingDot = "_f3-1";
export var recordingIndicator = "_f3-0";